// Mobile buy bar: appears once the product form's own button has scrolled out of view.
(() => {
  const submit = document.querySelector('.product-form__submit');
  const title = document.querySelector('.product__title h1');
  if (!submit || !title || !('IntersectionObserver' in window)) return;

  const bar = document.createElement('div');
  bar.className = 'dd-sticky-buy';

  const name = document.createElement('span');
  name.className = 'dd-sticky-buy__title';
  name.textContent = title.textContent.trim();

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'dd-sticky-buy__button';
  button.textContent = submit.textContent.trim();
  button.addEventListener('click', () => submit.click());

  bar.append(name, button);
  document.body.append(bar);

  new IntersectionObserver(([entry]) => {
    bar.classList.toggle('is-visible', !entry.isIntersecting && !submit.disabled);
    button.textContent = submit.textContent.trim();
  }).observe(submit);
})();
